import { useMonitorPublicMint } from "../../hooks/use-monitor-public-mint"

interface PublicMintMonitorProps {
  publicMintId: string
  render: ({ data }: { data: any }) => JSX.Element
}

const PublicMintMonitor = (props: PublicMintMonitorProps) => {
  const [publicMint] = useMonitorPublicMint(props?.publicMintId)

  return props.render({ data: publicMint })
}

export default PublicMintMonitor
